const createCSV = () => {

  // create and trigger download
  const download_csv = (csv, filename) => {
    let csvFile;
    let downloadLink;

    // CSV FILE
    csvFile = new Blob([csv], { type: "text/csv" });

    // Download link
    downloadLink = document.createElement("a");

    // File name
    downloadLink.download = filename;

    // We have to create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Make sure that the link is not displayed
    downloadLink.style.display = "none";

    // Add the link to your DOM
    document.body.appendChild(downloadLink);

    // Lanzamos
    downloadLink.click();
  };

  // loop over table and build the CSV structure
  const export_table_to_csv = (html, filename) => {
    let csv = [];
    let rows = document.querySelectorAll("table tr");
    for (let i = 0; i < rows.length; i++) {
      let row = [], 
      cols = rows[i].querySelectorAll("td, th");
      if (rows[i].style.display !== 'none'){
        for (let j = 0; j < cols.length; j++) {
          row.push(cols[j].innerText);
        }
        csv.push(row.join(","));
      }
    }
    // Download CSV
    download_csv(csv.join("\n"), filename);
  };

  // make sure we have a button
  let exportButton = document.querySelector(".js-createCSV");
  if (exportButton) {
    exportButton.addEventListener("click", function () {
      let html = document.querySelector("table").outerHTML;
      export_table_to_csv(
        html,
        "assessments-" + Math.floor(Date.now() / 1000) + ".csv"
      );
    });
  }

};

export { createCSV };
